




import { defineComponent } from '@vue/composition-api';

import PanelWithNotifyGroupEditor from '@/components/Setting/PanelWithNotifyGroupEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithNotifyGroupEditor,
  },
  // setup() {},
});

export default Edit;
